export default __webpack_public_path__ + "static/media/lk.33849c85.svg";